import React, { useState } from "react";
import { useToggle } from "hooks";

function SSSAccordion({ title, children }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="faqAccordionColspan">
      <div className={`w-full p-3 border-2 ${open ? "rounded-b-none border-b" : "rounded-md"}`}>
        <div onClick={() => setOpen(!open)} className="faqTitleStyle">
          <p className="font-semibold text-md">{title}</p>
          {!open ?
            <i className="text-xl font-semibold ri-add-line"></i>
            : <i className="text-xl font-semibold ri-subtract-line"></i>
          }
        </div>


      </div>
      <div className={`faqChildrenStyle ${open ? "block" : "hidden"} `}>

        {children}
      </div>
    </div>

  );
}

export default SSSAccordion;
